import type { ComponentType } from "react";
import {
  ClipboardList,
  Wallet,
  House,
  Umbrella,
  Gem,
  PiggyBank,
  ReceiptText,
  Calculator,
} from "lucide-react";

export type ModuleStatus = "not_started" | "in_progress" | "completed";

export interface ModuleDefinition {
  readonly id: string;
  readonly title: string;
  readonly description: string;
  readonly icon: ComponentType<{ className?: string; size?: number }>;
  readonly iconBgColor: string;
  readonly iconColor: string;
}

export const MODULE_DEFINITIONS: readonly ModuleDefinition[] = [
  {
    id: "estate-setup",
    title: "Estate Setup",
    description:
      "We'll walk you through the key details we need to get your estate organized and ready to manage.",
    icon: ClipboardList,
    iconBgColor: "bg-stone-100",
    iconColor: "text-primary",
  },
  {
    id: "real-estate",
    title: "Real Estate",
    description: "Homes, land, and property to transfer or sell.",
    icon: House,
    iconBgColor: "bg-purple-100",
    iconColor: "text-purple-800",
  },
  {
    id: "financial-accounts",
    title: "Financial Accounts",
    description: "Bank, credit card, investment, and retirement accounts to transfer or close.",
    icon: Wallet,
    iconBgColor: "bg-green-100",
    iconColor: "text-green-800",
  },
  {
    id: "benefits-eligibility",
    title: "Insurance and Benefits",
    description: "Life insurance, pensions, and benefits your family may be entitled to claim.",
    icon: Umbrella,
    iconBgColor: "bg-teal-50",
    iconColor: "text-teal-600",
  },
  {
    id: "personal-property",
    title: "Tangible Personal Property",
    description: "Vehicles, jewelry, art, and other belongings to transfer or distribute.",
    icon: Gem,
    iconBgColor: "bg-rose-50",
    iconColor: "text-rose-500",
  },
  {
    id: "other-assets",
    title: "Other Assets",
    description:
      "Receivables, stock options, royalties, prepaid services, and other less common assets.",
    icon: PiggyBank,
    iconBgColor: "bg-yellow-50",
    iconColor: "text-yellow-600",
  },
  {
    id: "debts-loans",
    title: "Debts and Loans",
    description: "What's owed by the estate, paid before anything is distributed.",
    icon: ReceiptText,
    iconBgColor: "bg-orange-50",
    iconColor: "text-orange-500",
  },
  {
    id: "expenses",
    title: "Estate Expenses",
    description: "Out-of-pocket costs that may be reimbursable to the estate.",
    icon: Calculator,
    iconBgColor: "bg-blue-100",
    iconColor: "text-blue-600",
  },
] as const;
